import { render, staticRenderFns } from "./BulkSms.vue?vue&type=template&id=f292bd32&scoped=true&"
import script from "./BulkSms.vue?vue&type=script&lang=js&"
export * from "./BulkSms.vue?vue&type=script&lang=js&"
import style0 from "./BulkSms.vue?vue&type=style&index=0&id=f292bd32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f292bd32",
  null
  
)

component.options.__file = "BulkSms.vue"
export default component.exports